module.exports = "<app-header-nav></app-header-nav>\n<div class=\"m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop \tm-container m-container--responsive m-container--xxl m-page__container m-body\">\n  <div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n<app-footer style=\"text-align:center;position: fixed;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    height: 64px;\n    margin-bottom: 0px;\n    padding: 18px 0px 20px 0px;\"></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main